import { Component } from '@angular/core';

@Component({
  selector: 'app-no-content-found',
  standalone: false,
  templateUrl: './no-content-found.component.html',
  styleUrl: './no-content-found.component.css'
})
export class NoContentFoundComponent {
     
}
